//@ts-ignore
import {Stack} from './stacks/Stack';
import {Stacks} from '../../../../base/Stacks';
import {ActiveData} from '../../../../data/ActiveData';
import {ArrayWrapEvent} from '../../../../data/active_data/base/static_config_data/array_wrap/ArrayWrapEvent';
import {ArrayWrapEventData} from '../../../../data/active_data/base/static_config_data/array_wrap/ArrayWrapEventData';
import {CardStackData} from '../../../../data/active_data/field_config/CardStackData';
import {StackEvents} from './stacks/stack/StackEvents';

export class TableStacks extends Stacks
{
    constructor() {
        super();
        ActiveData.root.card_stacks.addListener(ArrayWrapEvent.ELEMENT_REMOVED, this.onStackRemoved, this);
        ActiveData.root.card_stacks.addListener(ArrayWrapEvent.ELEMENT_ADDED, this.onStackAdded, this);
    }

    /**
     * Регистрируем и отрисовываем первоначальный список колод от сервера
     */
    async initialize(): Promise<void> {
        let stack: Stack;
        let masterLocked: CardStackData[] = ActiveData.root.card_stacks.classes.filter(item => item.masterLocked);
        let notMasterLocked: CardStackData[] = ActiveData.root.card_stacks.classes.filter(item => !item.masterLocked);
        for (let cardsStackData of masterLocked) {
            stack = new Stack(cardsStackData);
            await this.addStack(stack);
        }
        for (let cardsStackData of notMasterLocked) {
            if (cardsStackData.cards.length == 0) {
                continue;
            }
            stack = new Stack(cardsStackData);
            await this.addStack(stack);
        }
    }

    /**
     * Регистрируем и отрисовываем колоду в холдере
     * @param stack - добавляемая в холдер колода
     */
    async addStack(stack: Stack, initialize: boolean = true): Promise<void> {
        return super.addStack(stack, initialize);
    }

    /**
     * Убираем колоду из холдера
     * @param {Stack} stack - убираемая из холдера колода
     */
    removeStack(stack: Stack): void {
        super.removeStack(stack);
    }

    destroy(): void {
        ActiveData.root.card_stacks.removeListener(ArrayWrapEvent.ELEMENT_REMOVED, this.onStackRemoved, this);
        ActiveData.root.card_stacks.removeListener(ArrayWrapEvent.ELEMENT_ADDED, this.onStackAdded, this);
        super.destroy();
    }

    protected async onStackAdded(data: ArrayWrapEventData<CardStackData>): Promise<void> {
        let stack: Stack = new Stack(data.value);
        await this.addStack(stack);
        dispatchEvent(new MessageEvent(StackEvents.STACK_CREATED, {data: {stack: stack}}));
        await super.onStackAdded(data);
    }

    private onStackRemoved(data: ArrayWrapEventData<CardStackData>): void {
        let stack: Stack | undefined = this.stacks.find((item: Stack) => {
            return item.activeData == data.value;
        });
        if (stack) {
            this.removeStack(stack);
            stack.toDestroy = true;
        }
    }
}
